<template>
  <v-container
    id="loginBackgroundComponent"
    fluid
  >
    <v-row class="d-flex flex-column flex-md-row-reverse thing">
      <v-col
        cols="12"
        md="6"
        class="d-flex justify-center align-center full-height"
      >
        <v-row class="d-flex flex-column">
          <v-col
            md="12"
            class="d-flex justify-center align-center"
          >
            <img
              v-if="tenant.settings.logo === null"
              src="/img/logo.svg"
              alt="Flo Logo in Blue"
              class="logo-size"
            >
            <img
              v-else
              :src="'/agency-file/logo'"
              alt="Flo Logo in Blue"
              class="logo-size"
            >
          </v-col>

          <v-col
            md="12"
            class="d-flex justify-center align-center text-small"
          >
            <a
              href="https://flo.co.uk"
              title="Recruitment Software by Flo"
              target="_blank"
              class="powered-by"
            >Recruitment Software by Flo</a>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        md="6"
        class="parallelogram-container"
      >
        <div
          class="parallelogram d-md-flex flex-row justify-center"
          :class="{'align-center': showLoginForm}"
        >
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <new-login-component
                  v-if="showLoginForm"
                  :tenant="tenant"
                  @register="showRegister"
                  @forgotten="showForgotten()"
                />

                <new-forgotten-password-component
                  :show-forgotten="showForgottenForm"
                  @register="showRegister"
                  @back="showLogin"
                />

                <select-agency-component
                  v-if="showSelectAgencyForm"
                  :show-select-agency="showSelectAgencyForm"
                  @register="showRegister"
                  @back="showSelectAgencyForm = false"
                />
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-col>
    </v-row>
    <div
      v-if="showRegisterForm"
      class="d-flex justify-center align-center pab"
    >
      <transition name="fade">
        <candidate-registration-component
          v-if="showRegisterForm"
          :show-register="true"
          class="register-comp"
          :tenant="tenant"
          @loginBack="showLogin()"
        />
      </transition>
    </div>
  </v-container>
</template>
<script>
export default {
  name: 'LoginBackgroundComponent',
  props: {
    tenant: {
      type: Object,
      default: () => {
        return {
          settings: {
            logo: null
          }
        }
      }
    }
  },
  data: () => ({
    showForgottenForm: false,
    showRegisterForm: false,
    showSelectAgencyForm: false,
    showLoginForm: true,
    logDetail: {},
    newRegistration: false,
    existAccount: false,
    agencies: [],
    invites: [],
    passwordResetPrompt: false
  }),
  computed: {
    //
  },
  created () {
    //
  },
  methods: {
    disableForm () {
      this.showRegisterForm = false
      this.showLoginForm = false
      this.showForgottenForm = false
      this.showForgotten = false
      this.showSelectAgencyForm = false
    },
    showRegister () {
      this.disableForm()
      this.showRegisterForm = true
    },
    showForgotten () {
      this.disableForm()
      this.showForgottenForm = true
    },
    showSelectAgency (response) {
      this.agencies = response.agencies
      this.invites = response.invites
      this.passwordResetPrompt = response.passwordResetPrompt
      this.disableForm()
      this.showSelectAgencyForm = true
    },
    showExistAccount () {
      this.disableForm()
    },
    showLogin () {
      this.disableForm()
      this.showLoginForm = true
    }
  }
}
</script>
<style lang="scss">
@import './resources/sass/variables';
@import './resources/sass/agencyTheming';
#loginBackgroundComponent {
    .powered-by {
        text-decoration: none;
        color: grey;
    }
  .pab {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .register-comp{
    max-width: 95vw;
  }
  @media screen and (min-width: 960px){
    .full-height{
      height: 100vh;
    }
    .logo-size{
      width: auto;
    }
  }
  & > .thing > .parallelogram-container > .parallelogram {
    position: fixed;
    bottom: -10%;
    left: 0;
    width: 100vw;
    height: 70vh;
    min-height: 600px;
    background-color: $agencyColorPrimary;
    // transform: skewY(10deg);
    box-shadow: 6px 0px 10px 5px rgba(0,0,0,0.1);
    @media screen and (min-width: 960px) {
      bottom: 0;
      width: 600px;
      height: 100vh;
      // transform: skewX(-15deg);
    }
    @media screen and (min-width: 1200px) {
      width: 50vw;
    }
  }
  .unskew{
    text-align: center;
    // transform: skewY(-10deg);
    color: white;
  }
  @media screen and (min-width: 960px) {
    .unskew{
      max-width: 65%;
      // transform: skewX(15deg);
      margin: 1rem 1rem;
      padding: 1rem 1rem;
    }
  }
}
</style>
